<template>
  <div id="app" v-if="show">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta || !$route.meta.keepAlive" />
  </div>
</template>
<script>
import { fetchGetTmpUuid, fetchFbReport } from '@/api'
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY } from './utils/constant'
import Cookies from 'js-cookie'
import { isCurLogin, login } from '@/components/login/login'
import { setCookieFbc, setCookieAdId } from './utils/base'


export default {
  name: 'App',
  data() {
    return {
      show: false
      // Define any global data properties here
    }
  },
  methods: {
    async getUuid(){
      try {
        if(Cookies.get(USER_ID_COOKIES_KEY)){
          this.show = true
          setTimeout(() => {
            fetchFbReport({}, 'PageView')            
          }, 100);
          return
        }
        await fetchGetTmpUuid()
        this.show = true
        setTimeout(() => {
          fetchFbReport({}, 'PageView')            
        }, 100);
      }catch (error) {
        console.error('Error fetching UUID:', error)
      }
    },
    reportFb(){
      console.log('reportFb')
    }
  },
  mounted() {
    setCookieAdId();
    setCookieFbc();
    this.getUuid()
    isCurLogin.value = login.isLogin()


    // Perform any actions when the component is mounted
  }
}
</script>


<style lang="less">

</style>
